<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" align="center" justify="center">
                <h1>Create User</h1>
            </v-col>
        </v-row>

        <v-row align="center" justify="center">
            <v-col cols="12" align="center" justify="center">
                <UserEditForm mode="create" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UserEditForm from './Components/UserEditForm';
export default {
    components: { UserEditForm },

    props: ['mode'],
};
</script>
